import { HttpErrorResponse, HttpRequest } from '@angular/common/http';

import { AppInsightsBaseService } from '@kros-sk/core/application-insights';
import { ToastService } from '@kros-sk/ui/toast';

import { LostNetworkConnectionToastComponent } from '../ui/lost-network-connection-toast/lost-network-connection-toast.component';

export function handleProgressEventFailed(
  appInsights: AppInsightsBaseService,
  toastService: ToastService,
  error: HttpErrorResponse,
  req: HttpRequest<any>
): void {
  // error.error can be aborted/error
  appInsights.trackEvent('ProgressEventFailed', {
    error: error.error,
    errorStatus: error.status,
    requestUrl: req?.url,
    requestMethod: req?.method,
  });
  console.log('Client killed connection', error, error.error);

  if (error.error instanceof ProgressEvent) {
    toastService.show(LostNetworkConnectionToastComponent, {
      classname: 'kros-toast kros-warning',
      delay: 10000,
    });
  }
}
